
(function () {
  'use strict';

  var TEXTE = null;
  function tx(k, rueckfall, werte) {
    if (!TEXTE) {
      try {
        var el = document.querySelector('script[data-setup-texte]');
        if (el) TEXTE = JSON.parse(el.textContent) || {};
      } catch (e) { TEXTE = {}; }
    }
    var s = (TEXTE && TEXTE[k]) || rueckfall || '';
    if (werte) {
      s = s.replace(/\{(\w+)\}/g, function (m, n) { return werte[n] != null ? String(werte[n]) : m; });
    }
    return s;
  }

  function wurzel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  if (window.__dzbLaeuft) return;
  window.__dzbLaeuft = true;

  function proxyVon() {
    return (window.FinderClean && window.FinderClean.proxy) || '/apps/monitor-db';
  }

  function auswahl() {
    try { return JSON.parse(localStorage.getItem('3idee_auswahl') || 'null') || null; }
    catch (e) { return null; }
  }

  var wartet = 0;
  function bewerten(frisch) {
    var kaesten = [].slice.call(document.querySelectorAll('[data-dzb-platte]'));
    if (!kaesten.length) return;

    var offen = kaesten.filter(function (k) {
      return frisch || !k.hasAttribute('data-dzb-bewertet');
    });
    if (!offen.length) return;
    kaesten.forEach(function (k) { k.setAttribute('data-dzb-bewertet', ''); });

    if (typeof window.Verstaerkung === 'undefined') {
      if (wartet++ > 10) return;
      setTimeout(function () { bewerten(true); }, 200);
      return;
    }
    wartet = 0;

    var a = auswahl() || {};
    var t = a.tisch || null;
    var kg = null;
    if (a.tischKg && a.tischKg.kg && a.tischKg.mount) {
      var korb = (kaesten[0].getAttribute('data-dzb-korb') || '').split(',');
      if (korb.indexOf(a.tischKg.mount) > -1) kg = a.tischKg.kg;
    }
    if (!t && !kg) return;

    window.Verstaerkung.pruefe({ proxy: proxyVon(), art: (t && t.art) || '', kg: kg })
      .then(function (paket) {
        var urteil = paket && paket.TABLE_REINFORCEMENT;
        if (!urteil) return;

        kaesten.forEach(function (kasten) {
          var unten = kasten.getAttribute('data-dzb-ort') === 'liste';
          kasten.hidden = !unten;
          if (!unten) return;

          var kopf = kasten.querySelector('[data-dzb-titel]');
          if (kopf && (urteil.stufe === 'REQUIRED' || urteil.stufe === 'RECOMMENDED')) {
            var pflicht = urteil.stufe === 'REQUIRED';
            kopf.textContent = kasten.getAttribute(pflicht ? 'data-dzb-wort-pflicht' : 'data-dzb-wort-empfohlen')
              || kopf.textContent;
          }

          if (urteil.text) {
            var inhalt = kasten.querySelector('[data-dzb-info-inhalt]');
            var knopf = kasten.querySelector('[data-dzb-info]');
            if (inhalt) inhalt.innerHTML = urteil.text;
            if (knopf) knopf.hidden = false;
          }
        });
      });
  }

  var pflichtLaeuft = false;
  function pflichtteile() {
    var huelle = document.querySelector('[data-dzp]:not([data-dzp-fertig])');
    if (!huelle || pflichtLaeuft) return;
    var refs = ((auswahl() || {}).refs || []).map(String);
    huelle.setAttribute('data-dzp-fertig', '');
    if (!refs.length) return;
    var zahl = {};
    refs.forEach(function (r) { zahl[r] = (zahl[r] || 0) + 1; });
    var korb = huelle.getAttribute('data-dzp-korb') || '';
    pflichtLaeuft = true;
    var proxy = proxyVon();

    Promise.all(Object.keys(zahl).slice(0, 4).map(function (ref) {
      return hol(proxy + '/monitors/' + encodeURIComponent(ref) + '/compatibility')
        .then(function (json) { return { ref: ref, json: json }; });
    })).then(function (antworten) {
      var teile = {};
      antworten.forEach(function (a) {
        var recs = (a.json && a.json.ok && a.json.data && a.json.data.recommendations) || [];
        recs.forEach(function (rec) {
          if (rec.requirement !== 'REQUIRED' || rec.oem_supplied) return;
          (rec.products || []).forEach(function (p) {
            if (!p || !p.handle || p.in_shop === false) return;
            if (p.type === 'TABLE_REINFORCEMENT' || p.type === 'PLATE') return;
            if (korb.indexOf(',' + String(p.handle).toLowerCase() + ',') > -1) return;
            var t = teile[p.handle] || (teile[p.handle] = { handle: p.handle, sku: p.shopify_sku || p.sku, satz: rec.message || '', menge: 0, bild: p.image_url });
            t.menge += zahl[a.ref];
          });
        });
      });
      var liste = Object.keys(teile).map(function (h) { return teile[h]; });
      return Promise.all(liste.map(function (g) {
        return hol(wurzel() + 'products/' + encodeURIComponent(g.handle) + '.js').then(function (prod) {
          if (!prod || !prod.variants) return null;
          var su = String(g.sku || '').toUpperCase(), v = null;
          prod.variants.forEach(function (k) { if (!v && su && String(k.sku || '').toUpperCase() === su) v = k; });
          if (!v) prod.variants.forEach(function (k) { if (!v && k.available) v = k; });
          if (!v || !v.available) return null;
          g.variante = v.id; g.preis = v.price;
          g.titel = String(prod.title || '').split('|')[0].trim();
          if (prod.featured_image) g.bild = prod.featured_image;
          return g;
        });
      }));
    }).then(function (fertig) {
      pflichtLaeuft = false;
      fertig = (fertig || []).filter(Boolean);
      var ziel = huelle.querySelector('[data-dzp-liste]');
      if (!fertig.length || !ziel) return;
      var wort = huelle.getAttribute('data-dzp-wort') || '';
      var knopfwort = huelle.getAttribute('data-dzp-knopf') || '';
      var wofuer = huelle.getAttribute('data-dzp-wofuer') || '';
      ziel.innerHTML = fertig.map(function (g) {
        return '<div class="dzb__karte">'
          + '<div class="dzb__zeile">'
          +   '<span class="dzb__bild">' + (g.bild ? '<img src="' + esc(g.bild) + '" alt="" loading="lazy">' : '') + '</span>'
          +   '<span class="dzb__txt">'
          +     '<span class="dzb__name">' + (g.menge > 1 ? g.menge + '\u00d7 ' : '') + esc(g.titel) + '</span>'
          +     '<span class="dzp__stufe">' + esc(wort)
          +       (g.satz ? ' <button class="dzp__i" type="button" data-dzb-info aria-expanded="false" aria-label="' + esc(wofuer) + '">i</button>' : '')
          +     '</span>'
          +     '<span class="dzb__preis">' + esc(geld(g.preis * g.menge)) + '</span>'
          +   '</span>'
          +   '<button class="dzb__legen" type="button" data-dzb-legen="' + g.variante + '" data-dzb-menge="' + g.menge + '">' + esc(knopfwort) + '</button>'
          + '</div>'
          + (g.satz ? '<div class="dzb__mehr-inhalt" data-dzb-info-inhalt hidden>' + esc(g.satz) + '</div>' : '')
          + '</div>';
      }).join('');
      huelle.hidden = false;
    }).catch(function () { pflichtLaeuft = false; });
  }

  window.__drawerVerstaerkungBewerten = function (frisch) {
    bewerten(frisch);
    engineVorschlaege();
    pflichtteile();
  };

  if (window.__drawerZubehoerBereit) return;
  window.__drawerZubehoerBereit = true;

  function hol(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  var engineLaeuft = false;

  function engineVorschlaege() {
    var rahmen = [].slice.call(document.querySelectorAll('[data-dzb]'));
    if (!rahmen.length || engineLaeuft) return;

    var refs = ((auswahl() || {}).refs || []).map(String);
    if (!refs.length) return;

    var einmal = [];
    refs.forEach(function (r) { if (einmal.indexOf(r) < 0) einmal.push(r); });
    einmal = einmal.slice(0, 4);

    engineLaeuft = true;
    var proxy = proxyVon();

    Promise.all(einmal.map(function (ref) {
      return hol(proxy + '/monitors/' + encodeURIComponent(ref) + '/compatibility');
    })).then(function (antworten) {
      var gefunden = [];
      antworten.forEach(function (json) {
        var recs = (json && json.ok && json.data && json.data.recommendations) || [];
        recs.forEach(function (rec) {
          if (rec.requirement !== 'OPTIONAL') return;
          (rec.products || []).forEach(function (prod) {
            if (!prod || !prod.handle || prod.in_shop === false) return;
            if (prod.type === 'ADAPTER' || prod.type === 'PLATE') return;
            var schon = false;
            gefunden.forEach(function (g) { if (g.handle === prod.handle) schon = true; });
            if (schon) return;
            gefunden.push({
              handle: prod.handle,
              sku: prod.shopify_sku || prod.sku,
              name: prod.name,
              bild: prod.image_url,
              satz: rec.message || ''
            });
          });
        });
      });
      if (!gefunden.length) { engineLaeuft = false; return null; }

      var korb = (rahmen[0].getAttribute('data-dzb-korb') || '').toLowerCase();
      gefunden = gefunden.filter(function (g) {
        return korb.indexOf(',' + g.handle.toLowerCase() + ',') < 0;
      });
      if (!gefunden.length) { engineLaeuft = false; return null; }

      return Promise.all(gefunden.map(function (g) {
        return hol(wurzel() + 'products/' + encodeURIComponent(g.handle) + '.js').then(function (prod) {
          if (!prod || !prod.variants || !prod.variants.length) return null;
          var su = String(g.sku || '').toUpperCase();
          var v = null;
          prod.variants.forEach(function (k) {
            if (!v && su && String(k.sku || '').toUpperCase() === su) v = k;
          });
          if (!v && !su) prod.variants.forEach(function (k) { if (!v && k.available) v = k; });
          if (!v || !v.available) return null;
          g.preis = v.price;
          g.variante = v.id;
          g.titel = String(prod.title || g.name || '').split('|')[0].trim();
          if (!g.bild && prod.featured_image) g.bild = prod.featured_image;
          return g;
        });
      })).then(function (fertig) {
        zeichne(rahmen, fertig.filter(Boolean));
        engineLaeuft = false;
      });
    }).catch(function () { engineLaeuft = false; });
  }

  function geld(cent) {
    var nk = (cent % 100) ? 2 : 0;
    try {
      return (cent / 100).toLocaleString('de-DE',
        { minimumFractionDigits: nk, maximumFractionDigits: 2 }) + '\u00a0\u20ac';
    } catch (e) { return (cent / 100) + '\u00a0\u20ac'; }
  }

  function esc(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function gruppeFuerHalt(alltagsKasten) {
    var vorhanden = [].slice.call(document.querySelectorAll('[data-dzb-platte]'))
      .filter(function (g) { return !g.hidden; })[0];
    if (vorhanden) return vorhanden;

    var eigen = document.querySelector('[data-dzb-halt]');
    if (eigen) return eigen;

    eigen = document.createElement('div');
    eigen.className = 'dzb';
    eigen.setAttribute('data-dzb-halt', '');
    var wort = alltagsKasten.getAttribute('data-dzb-halt-titel') || '';
    eigen.innerHTML = wort ? '<p class="dzb__titel">' + esc(wort) + '</p>' : '';
    alltagsKasten.parentNode.insertBefore(eigen, alltagsKasten);
    return eigen;
  }

  function zeichne(rahmen, liste) {
    if (!liste.length) return;
    rahmen.forEach(function (r) {
      var ziel = gruppeFuerHalt(r);
      if (ziel.hasAttribute('data-dzb-engine')) return;
      ziel.setAttribute('data-dzb-engine', '');

      var knopfwort = r.getAttribute('data-dzb-knopf') || tx('hinzufuegen', 'Hinzufügen');
      var html = liste.map(function (g) {
        return '<div class="dzb__karte" data-dzb-aus-engine>'
          + '<div class="dzb__zeile">'
          +   '<span class="dzb__bild">'
          +     (g.bild ? '<img src="' + esc(g.bild) + '" alt="" loading="lazy">' : '')
          +   '</span>'
          +   '<span class="dzb__txt">'
          +     '<span class="dzb__namezeile">'
          +       '<span class="dzb__name">' + esc(g.titel) + '</span>'
          +       (g.satz
                   ? '<button class="dzb__i" type="button" data-dzb-info'
                     + ' aria-expanded="false" aria-label="' + esc(tx('wofuer', 'Wofür ist das?')) + '">i</button>'
                   : '')
          +     '</span>'
          +     '<span class="dzb__preis">' + esc(geld(g.preis)) + '</span>'
          +   '</span>'
          +   '<button class="dzb__legen" type="button" data-dzb-legen="' + g.variante + '">'
          +     esc(knopfwort)
          +   '</button>'
          + '</div>'
          + (g.satz
             ? '<div class="dzb__mehr-inhalt" data-dzb-info-inhalt hidden>' + g.satz + '</div>'
             : '')
          + '</div>';
      }).join('');

      var titel = ziel.querySelector('.dzb__titel');
      if (titel) titel.insertAdjacentHTML('afterend', html);
      else ziel.insertAdjacentHTML('afterbegin', html);
      ziel.hidden = false;
    });
  }

  document.addEventListener('click', function (e) {
    var info = e.target.closest && e.target.closest('[data-dzb-info]');
    if (info) {
      e.preventDefault();
      var kasten = info.closest('.dzb__karte') || info.closest('[data-dzb-platte]');
      var inhalt = kasten && kasten.querySelector('[data-dzb-info-inhalt]');
      if (!inhalt) return;
      var offen = !inhalt.hidden;
      inhalt.hidden = offen;
      info.setAttribute('aria-expanded', String(!offen));
      return;
    }

    var knopf = e.target.closest && e.target.closest('[data-dzb-legen]');
    if (!knopf) return;

    e.preventDefault();

    var variante = Number(knopf.getAttribute('data-dzb-legen'));
    if (!variante || knopf.disabled) return;

    if (typeof window.WarenkorbLegen !== 'function') return;

    knopf.disabled = true;
    var wort = knopf.textContent;
    knopf.textContent = '…';

    var menge = Number(knopf.getAttribute('data-dzb-menge')) || 1;
    window.WarenkorbLegen([{ id: variante, quantity: menge }], function (ok, grund) {
      if (ok) return;

      knopf.disabled = false;
      knopf.textContent = wort;
      if (grund) knopf.setAttribute('title', grund);
    });
  });

  document.addEventListener('finder:auswahl', function () {
    document.querySelectorAll('[data-dzb-engine]').forEach(function (r) {
      r.removeAttribute('data-dzb-engine');
      r.querySelectorAll('[data-dzb-aus-engine]').forEach(function (k) { k.remove(); });
    });
    document.querySelectorAll('[data-dzp]').forEach(function (h) { h.removeAttribute('data-dzp-fertig'); h.hidden = true; });
    bewerten(true);
    engineVorschlaege();
    pflichtteile();
  });
})();

(function () {
  'use strict';
  var start = function () {
    if (window.__drawerVerstaerkungBewerten) window.__drawerVerstaerkungBewerten();
  };
  if (!window.__drawerVerstaerkungBeobachter && window.MutationObserver) {
    var anstoss = null;
    window.__drawerVerstaerkungBeobachter = new MutationObserver(function () {
      clearTimeout(anstoss);
      anstoss = setTimeout(start, 80);
    });
    window.__drawerVerstaerkungBeobachter.observe(document.documentElement,
                                                 { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
